var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "payment-create main-content" },
    [
      _c("div", { staticClass: "page-header" }, [
        _c("h3", { staticClass: "page-title" }, [
          _vm._v(_vm._s(_vm.$t("general.action_record"))),
        ]),
        _vm._v(" "),
        _c("ol", { staticClass: "breadcrumb" }, [
          _c(
            "li",
            { staticClass: "breadcrumb-item" },
            [
              _vm.userType == "super_admin"
                ? _c(
                    "router-link",
                    {
                      attrs: {
                        slot: "item-title",
                        to: "/super-admin/dashboard",
                      },
                      slot: "item-title",
                    },
                    [_vm._v(_vm._s(_vm.$t("general.home")))]
                  )
                : _vm.userType == "supplier"
                ? _c(
                    "router-link",
                    {
                      attrs: { slot: "item-title", to: "/supplier/dashboard" },
                      slot: "item-title",
                    },
                    [_vm._v(_vm._s(_vm.$t("general.home")))]
                  )
                : _vm.userType == "anchor"
                ? _c(
                    "router-link",
                    {
                      attrs: { slot: "item-title", to: "/anchor/dashboard" },
                      slot: "item-title",
                    },
                    [_vm._v(_vm._s(_vm.$t("general.home")))]
                  )
                : _vm.userType == "funder"
                ? _c(
                    "router-link",
                    {
                      attrs: { slot: "item-title", to: "/funder/dashboard" },
                      slot: "item-title",
                    },
                    [_vm._v(_vm._s(_vm.$t("general.home")))]
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "li",
            { staticClass: "breadcrumb-item" },
            [
              _vm.userType == "super_admin"
                ? _c(
                    "router-link",
                    {
                      attrs: {
                        slot: "item-title",
                        to: "/super-admin/invoices",
                      },
                      slot: "item-title",
                    },
                    [_vm._v(_vm._s(_vm.$tc("invoices.invoice", 2)))]
                  )
                : _vm.userType == "supplier"
                ? _c(
                    "router-link",
                    {
                      attrs: { slot: "item-title", to: "/supplier/invoices" },
                      slot: "item-title",
                    },
                    [_vm._v(_vm._s(_vm.$tc("invoices.invoice", 2)))]
                  )
                : _vm.userType == "anchor"
                ? _c(
                    "router-link",
                    {
                      attrs: { slot: "item-title", to: "/anchor/invoices" },
                      slot: "item-title",
                    },
                    [_vm._v(_vm._s(_vm.$tc("invoices.invoice", 2)))]
                  )
                : _vm.userType == "funder"
                ? _c(
                    "router-link",
                    {
                      attrs: { slot: "item-title", to: "/funder/invoices" },
                      slot: "item-title",
                    },
                    [_vm._v(_vm._s(_vm.$tc("invoices.invoice", 2)))]
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c("li", { staticClass: "breadcrumb-item" }, [
            _vm._v(_vm._s(_vm.$t("general.action_record"))),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "page-actions row" }, [
          _vm.invoiceType != "preapproved" &&
          (_vm.userType == "anchor" || _vm.userType == "supplier") &&
          _vm.invoiceStatus != "DRAFT"
            ? _c(
                "button",
                {
                  staticClass:
                    "mr-3 invoice-action-btn base-button btn btn-outline-primary default-size",
                  attrs: { outline: "", color: "theme" },
                  on: { click: _vm.downloadExcelReport },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("general.alfalah_connect")) +
                      "\n      "
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.invoiceType != "preapproved"
            ? _c(
                "a",
                {
                  staticClass:
                    "mr-3 invoice-action-btn base-button btn btn-outline-primary default-size",
                  attrs: {
                    href:
                      "/invoices/download_all_files/" + _vm.invoiceUniqueHash,
                    target: "_blank",
                    outline: "",
                    color: "theme",
                  },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("general.download_all_files")) +
                      "\n      "
                  ),
                ]
              )
            : _vm.invoiceType === "preapproved" &&
              _vm.userType === "super_admin"
            ? _c(
                "a",
                {
                  staticClass:
                    "mr-3 invoice-action-btn base-button btn btn-outline-primary default-size",
                  attrs: {
                    href:
                      "/invoices/download_all_files/" + _vm.invoiceUniqueHash,
                    target: "_blank",
                    outline: "",
                    color: "theme",
                  },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("general.download_all_files")) +
                      "\n      "
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.hasInvoiceAttachments && _vm.invoiceUniqueHash
            ? _c(
                "a",
                {
                  staticClass:
                    "mr-3 invoice-action-btn base-button btn btn-outline-primary default-size",
                  attrs: {
                    href:
                      "/invoices/download_invoiceAttachment/" +
                      _vm.invoiceUniqueHash,
                    target: "_blank",
                    outline: "",
                    color: "theme",
                  },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("general.download_invoice_attachments")) +
                      "\n      "
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.hasPOAttachments === true && _vm.invoiceUniqueHash
            ? _c(
                "a",
                {
                  staticClass:
                    "mr-3 invoice-action-btn base-button btn btn-outline-primary default-size",
                  attrs: {
                    href:
                      "/invoices/download_poAttachment/" +
                      _vm.invoiceUniqueHash,
                    target: "_blank",
                    outline: "",
                    color: "theme",
                  },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("general.download_po_attachments")) +
                      "\n      "
                  ),
                ]
              )
            : _vm._e(),
        ]),
      ]),
      _vm._v(" "),
      _vm.invoiceType === "preapproved"
        ? _c("SinglePreapprovedInvoiceRow", {
            attrs: { "fetch-data": _vm.fetchData },
          })
        : _c("SingleInvoiceRow", { attrs: { "fetch-data": _vm.fetchData } }),
      _vm._v(" "),
      _c(
        "table-component",
        {
          ref: "table",
          attrs: {
            "show-filter": false,
            data: _vm.actionRecord,
            "table-class": "table",
          },
        },
        [
          _c("table-column", {
            attrs: {
              label: _vm.$t("invoices.date"),
              "sort-as": "invoice_date",
              show: "formattedCreatedAt",
            },
          }),
          _vm._v(" "),
          _c("table-column", {
            attrs: { label: _vm.$t("invoices.status"), "sort-as": "status" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (row) {
                  return [
                    _c("span", [
                      _vm._v(" " + _vm._s(_vm.$t("invoices.status"))),
                    ]),
                    _vm._v(" "),
                    _vm.userType == "anchor" && row.status == "SENT"
                      ? _c(
                          "span",
                          { class: "inv-status-" + row.status.toLowerCase() },
                          [_vm._v(_vm._s(_vm.$t("general.received")))]
                        )
                      : _vm.userType == "anchor" && row.status != "SENT"
                      ? _c(
                          "span",
                          { class: "inv-status-" + row.status.toLowerCase() },
                          [
                            _vm._v(
                              _vm._s(
                                row.status != "PARTIALLY_PAID"
                                  ? row.status
                                  : row.status.replace("_", " ")
                              )
                            ),
                          ]
                        )
                      : _vm.userType != "anchor"
                      ? _c(
                          "span",
                          { class: "inv-status-" + row.status.toLowerCase() },
                          [
                            _vm._v(
                              _vm._s(
                                row.status != "PARTIALLY_PAID"
                                  ? row.status
                                  : row.status.replace("_", " ")
                              )
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("table-column", {
            attrs: { label: _vm.$t("general.company_name") },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (row) {
                  return [
                    _vm._v(
                      "\n        " + _vm._s(row.company_name) + "\n      "
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }